import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import styles from './CustomSwitch.module.scss';

interface CustomSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  icon?: ReactNode;
  switchSize?: 'default' | 'ideas';
}

const CustomSwitch: FC<CustomSwitchProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  icon,
  switchSize = 'default',
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <Box className={styles.switchContainer}>
      <Box className={styles.switchLabelContainer}>
        {icon && <Box className={styles.switchIcon}>{icon}</Box>}
        <Typography
          variant="h10"
          className={styles.switchLabel}
        >
          {label}
        </Typography>
      </Box>
      <Box
        className={`${styles.switch} ${switchSize === 'ideas' ? styles.switchIdeas : ''} ${
          checked ? styles.checked : ''
        } ${disabled ? styles.disabled : ''}`}
        onClick={handleClick}
      >
        <Box
          className={`${styles.switchThumb} ${switchSize === 'ideas' ? styles.switchThumbIdeas : ''}`}
        />
      </Box>
    </Box>
  );
};

export default CustomSwitch;
